import { takeEvery } from 'redux-saga'
import { put, call, select } from 'redux-saga/effects'
import { updatePPFHoverSelector } from 'selectors'
import { UPDATE_PPF_HOVER } from 'actions/cameraActions'
import { notifyHoneybadgerAction } from 'actions/applicationActions'
import calculateDistanceToTarget from 'helpers/calculations/calculateDistanceToTarget'
import calculateHorizontalFieldOfView from 'helpers/calculations/calculateHorizontalFieldOfView'
import calculatePpf from 'helpers/calculations/calculatePpf'
import { updateUiAction } from 'actions/uiActions'
import { updateCalculatorAction } from 'actions/calculatorActions'

function calculateDistance(distanceInMeters, isImperial) {
  return distanceInMeters * (isImperial ? 3.281 : 1)
}

export function * updatePPFHover(action) {
  try {
    const { currentCamera, isImperial } = yield select(updatePPFHoverSelector)

    if (!currentCamera) return

    const { id, horizontalAngleOfView, horizontalResolution, tilt, markers: { camera }, model } = currentCamera
    const { latLng } = action

    yield put(updateCalculatorAction(latLng, 'ppfHoverPosition', id, true))

    if (typeof latLng === 'undefined') {
      yield put(updateUiAction({ ppfHover: {} }))
    } else {
      const distanceInMeters = yield call(google.maps.geometry.spherical.computeDistanceBetween, latLng, camera.getPosition())
      const distance = yield call(calculateDistance, distanceInMeters, isImperial)
      const distanceToTarget = yield call(calculateDistanceToTarget, { distance, tilt })
      const horizontalFieldOfView = yield call(calculateHorizontalFieldOfView, { horizontalAngleOfView, distance: distanceToTarget })
      const ppf = yield call(calculatePpf, { horizontalResolution, horizontalFieldOfView, model, distance: distanceToTarget })
      yield put(updateUiAction({ ppfHover: { distance, ppf } }))
    }
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

export function * watchUpdatePPFHover() {
  yield * takeEvery(UPDATE_PPF_HOVER, updatePPFHover)
}



// WEBPACK FOOTER //
// ./src/sagas/updatePPFHoverSaga.js